<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">
          Delete Template
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <p class="text-body-1">
            Are you sure you want to delete this template? This action cannot be undone.
          </p>
          <p v-if="template" class="text-body-2 mt-2 font-weight-medium">
            Template: {{ template.template_name }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_template } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: 'DeleteTemplateDialog',
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    template: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'deleted'],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    }
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        // Reset when dialog closes
      }
    }
  },
  methods: {
    handleClose() {
      this.dialog = false
    },
    async handleDelete() {
      this.loading = true

      try {
        const input = {
          template_id: this.template.template_id || this.template.id || '',
          template_status: 'DELETED',
          source: 'BMS'
        }
        
        const response = await client.graphql({
          query: edit_template,
          variables: {
            input: input,
          },
        })
        
        // console.log(response)
        const responseData = JSON.parse(response.data.edit_template)
        
        if (responseData.status == "SUCCESS") {
          this.loading = false
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Template deleted successfully",
            color: "success",
          }
          this.$emit('deleted', 0)
          this.handleClose()
        } else {
          this.loading = false
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to delete template",
            color: "error",
          }
        }
      } catch (error) {
        this.loading = false
        console.error('Error deleting template:', error)
        this.snackbar = {
          show: true,
          message: error.message || "Failed to delete template",
          color: "error",
        }
      }
    }
  }
}
</script>

<style scoped>
</style>

